<template>
    <CustomHeader :text="$t('report.directReport')" />
    <div class="report_container">
        <van-row class="sub_row">
            <van-col span="18" class="icon_text">
                <img src="@/assets/common/ppbxv2_user.png" alt="">
                <div class="">{{ $t('report.subordinate') }}</div>
            </van-col>
            <van-col span="6" class="alignment row_text">
                <div>{{ $t('report.effective') }}</div>
                <img v-if="dataSet.checked" src="@/assets/bauDo/enablenew.png" alt="" @click="clickToSwitch">
                <img v-else src="@/assets/common/kaiguan_guan.png" alt="" @click="clickToSwitch">
            </van-col>
        </van-row>

        <div class="table_container">
            <van-row class="tabel_head">
                <van-col span="8" class="tabel_alignment">{{ $t('report.name') }}</van-col>
                <van-col span="2" class="tabel_alignment">
                    <!-- <div class="line"></div> -->
                </van-col>
                <van-col span="6" class="tabel_alignment">{{ $t('report.deposit') }}</van-col>
                <van-col span="2" class="tabel_alignment">
                    <!-- <div class="line"></div> -->
                </van-col>
                <van-col span="6" class="tabel_alignment">{{ $t('report.bets') }}</van-col>
            </van-row>

            <van-row class="tabel_row" v-for="(item, index) in dataSet.descendantsList" :key="index" :style="{
                backgroundColor: index % 2 === 1 ? 'transparent' : '#1a1d22'
            }">
                <van-col span="9" class="tabel_alignment">
                    <div>{{ item.userName }}</div>
                    <div style="font-size: 10px; color:#9ba7be; padding-top: 5px;">ID: {{
                        item.userCode }}</div>
                </van-col>
                <van-col span="8" class="tabel_alignment">{{ item.totalRecharge + " / " + item.rechargeRequire
                }}</van-col>
                <van-col span="7" class="tabel_alignment">{{ item.totalTurnover + " / " + item.turnoverRequire
                }}</van-col>
            </van-row>
            <NoData v-if="dataSet.descendantsList?.length == 0 || !dataSet.descendantsList" />
            <div v-else class="noMoreData">{{ $t("common.NoMoreData") }}</div>
        </div>
    </div>

</template>
<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import NoData from '../components/common/noData.vue';
import { ReportData } from '@/view/report/supportScript';
import { defineProps, defineEmits } from 'vue';
const emits = defineEmits(['switchClick'])

const props = defineProps<{
    dataSet: ReportData
}>()
const clickToSwitch = () => {
    emits('switchClick')
}

</script>
<style scoped>
.report_container {
    min-height: 100vh;
    padding: 70px 15px;
    background: #090f1f;
}

.report_title {
    color: #fff;
    font-size: 15px;
    padding: 5px;
}

.row_feild {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 7px;
    color: rgba(255, 255, 255, 0.85);
    padding: 15px 20px;
    margin: 5px 0;
}

.alignment {
    display: flex;
    align-items: center;
}

.row_text {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.65);
    justify-content: right;
}

.row_text span {
    font-size: 15px;
    font-weight: 700;
    color: #FFAF00;
}

.row_text img {
    width: 35px;
    margin: 0 5px;
}

.sub_row {
    border-radius: 10px;
    background: #101629;
    padding: 15px;
    margin-top: 10px;
}

.icon_text {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    font-size: 15px;
    color: #fff;
}

.icon_text img {
    width: 30px;
}

.line {
    width: 1px;
    background: rgba(255, 255, 255, 0.15);
    height: 10px;
}

.tabel_head {
    padding: 20px 10px;
    background: #1a223a;
    /* box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.15); */
    /* border-radius: 10px 10px 0 0; */
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    margin-top: 10px;
}

.tabel_alignment {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.tabel_row {
    color: #6D788D;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 10px;
    font-size: 13px;
}

.tabel_row .van-col {
    padding: 10px 0;
    color: #9ba7be;
}

.table_container {
    margin-top: 5px;
}

.noMoreData {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #6D788D;
}
</style>